/**
 * Vue composable for common client device related functionality.
 * @author dgm11b
 */


import {ref, onMounted} from 'vue'

export function useDeviceType() {

    const os = ref('Other')

    onMounted (() => {
      let agent = navigator.userAgent
      if (agent.indexOf('iPad') > -1 || agent.indexOf('iPhone') > -1) {
        os.value = 'iOS'
      } else if (agent.indexOf('Android') > -1) {
        os.value = 'Android'
      } else if (agent.indexOf('Windows') > -1) {
        os.value = 'Windows'
      } else if (agent.indexOf('Macintosh') > -1) {
        os.value = 'Macintosh'
      }
    })

    return os;
    
}
  
  